import { useState, useEffect, useRef } from 'react';

export default function StockSectionNav({ sections = [], scrollContainerId }) {
  const [active, setActive] = useState(sections[0]?.id ?? '');

  useEffect(() => {
    const scroll = document.getElementById(scrollContainerId);
    if (!scroll) return;

    const els = sections.map(s => document.getElementById(s.id)).filter(Boolean);
    const obs = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { root: scroll, threshold: 0.15, rootMargin: '-48px 0px -65% 0px' }
    );
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, [sections, scrollContainerId]);

  function scrollTo(id) {
    const scroll = document.getElementById(scrollContainerId);
    const el = document.getElementById(id);
    if (scroll && el) scroll.scrollTo({ top: el.offsetTop - 48, behavior: 'smooth' });
    setActive(id);
  }

  return (
    <div className="section-nav">
      {sections.map(s => {
        const Icon = s.icon;
        return (
          <button
            key={s.id}
            className={`sn-link${active === s.id ? ' active' : ''}`}
            onClick={() => scrollTo(s.id)}
          >
            {Icon && <Icon size={14} />} {s.label}
          </button>
        );
      })}
    </div>
  );
}
